import { api, toCamelCase, toSnakeCase } from '../lib/api'
import { Product, ProductCreate, ProductUpdate } from '../types/product'

export const productApi = {
  async getAll(activeOnly: boolean = false): Promise<Product[]> {
    const params = activeOnly ? '?active_only=true' : ''
    const response = await api.get(`/products${params}`)
    return response.data.map((item: unknown) =>
      toCamelCase(item as Record<string, unknown>) as unknown as Product
    )
  },

  async getById(id: number): Promise<Product> {
    const response = await api.get(`/products/${id}`)
    return toCamelCase(response.data as Record<string, unknown>) as unknown as Product
  },

  async search(query: string, activeOnly: boolean = true): Promise<Product[]> {
    const params = new URLSearchParams({
      q: query,
      active_only: String(activeOnly),
    })
    const response = await api.get(`/products/search?${params}`)
    return response.data.map((item: unknown) =>
      toCamelCase(item as Record<string, unknown>) as unknown as Product
    )
  },

  async create(data: ProductCreate): Promise<Product> {
    const payload = toSnakeCase(data as unknown as Record<string, unknown>)
    const response = await api.post('/products', payload)
    return toCamelCase(response.data as Record<string, unknown>) as unknown as Product
  },

  async update(id: number, data: ProductUpdate): Promise<Product> {
    const payload = toSnakeCase(data as unknown as Record<string, unknown>)
    const response = await api.put(`/products/${id}`, payload)
    return toCamelCase(response.data as Record<string, unknown>) as unknown as Product
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/products/${id}`)
  },
}
